export default function Marquee({ items }) {
  const row = items.map((t) => `${t} —`).join(" ");
  return (
    <div data-testid="editorial-marquee" className="overflow-hidden border-y border-zinc-800/80 py-5 bg-[#0A0A0C]">
      <div className="animate-marquee flex whitespace-nowrap w-max">
        {[0, 1].map((i) => (
          <span key={i} aria-hidden={i === 1} className="mono text-xs tracking-[0.35em] text-zinc-600 uppercase pr-4">
            {row}&nbsp;
          </span>
        ))}
      </div>
    </div>
  );
}
